import React from "react";
import ReactDOM from "react-dom";
import { HashRouter } from "react-router-dom";
import App from "./App";
import FAQManagementPage from "./view/faq/FAQManagementPage";
import OrganizationSelectionModal from "./view/org/OrganizationSelectionModal";
import SlipEditPopup from "./view/hr/slip/SlipEditPopup";
// import SlipEditPanel from './view/hr/slip/SlipEditPanel'
import SlipDailyEmployeeTable from "./view/hr/slip/SlipDailyEmployeeTable";
import SlipContractorTable from "./view/hr/slip/SlipContractorTable";
// import AutoPartViewer from './view/autoparts/AutoPartViewer'
import ReportContractorWage from "./view/hr/report/ReportContractorWage";
import ReportFixingOrderPage from "./view/report/ReportFixingOrderPage";
import ExcelEmployeeWage from "./view/hr/report/ExcelEmployeeWage";
import ReportPendingWork from "./view/report/ReportPendingWork";
import ReportInvoice from "./view/report/ReportInvoice";
import ReportShopPurchaseOrder from "./view/report/ReportShopPurchaseOrder";
import ReportEmployee from "./view/hr/report/ReportEmployee";
import ReportEmployeeAbsence from "./view/hr/report/ReportEmployeeAbsence";
import ReportAdvanceSalary from "./view/hr/report/ReportAdvanceSalary";
import ReportSummary from "./view/hr/report/ReportSummary";
import ReportCashFlowRecord from "./view/report/ReportCashFlowRecord";
import ReportSubscription from "./view/report/ReportSubscription";
import ReportWithholdingTaxPage from "./view/report/ReportWithholdingTaxPage";
import ReportPickup from "./view/report/ReportPickup";
// import ReportMechanicWork from './view/report/ReportMechanicWork'
import ReportEmployeeAdvanceSalaryRecord from "./view/hr/report/ReportEmployeeAdvanceSalaryRecord";
import EmployeeEditPage from "./view/hr/employee/EmployeeEditPage";
// import WageDataGrid from './view/workdoc/WageDataGrid'
import SWTWorkDocDamage from "./view/workdoc/SWTWorkDocDamage";
import RCKWorkDocDamage from "./view/workdoc/RCKWorkDocDamage";
import SWTWorkDocDamageFasttrack from "./view/workdoc/fast/SWTWorkDocDamage";
// import SWTNewCustomerButton from './view/workdoc/SWTNewCustomerButton'
import SWTCustomerPage from "./view/workdoc/SWTCustomerPage";
import SWTNewCarButton from "./view/workdoc/SWTNewCarButton";
import SWTNewCarTypeButton from "./view/workdoc/SWTNewCarTypeButton";
import ReportWork from "./view/report/ReportWork";
import ReportAssetWork from "view/report/ReportAssetWork";
import ReportRefixedWork from "./view/report/ReportRefixedWork";
import ReportReceptionWork from "./view/report/ReportReceptionWork";
import ReportJobControlBoard from "./view/report/ReportJobControlBoard";
import Plan from "./view/workdoc/plan/Plan";
import MessageMenu from "./view/menu/MessageMenu";
import LangMenu from "view/menu/LangMenu";
import MessagePopup from "./view/menu/MessagePopup";
import InvoiceStatusMenuButton from "./view/menu/invoicestatus/InvoiceStatusMenuButton";
import PriceCompare from "./view/workdoc/pricecompare/PriceCompare";
import ReportPurchaseOrderPage from "./view/report/ReportPurchaseOrderPage";
import ReportQuotationPage from "./view/report/ReportQuotationPage";
import ReportInvoicePage from "./view/report/ReportInvoicePage";
import ReportReceiptPage from "./view/report/ReportReceiptPage";
import ReportTaxinvoicePage from "./view/report/ReportTaxinvoicePage";
import ReportCreditNotePage from "./view/report/ReportCreditNotePage";
import ReportDebitNotePage from "./view/report/ReportDebitNotePage";
import ReportBillingNotePage from "./view/report/ReportBillingNotePage";
import ReportReceptionPage from "./view/report/ReportReceptionPage";
import ReportReceiptVoucherPage from "./view/report/ReportReceiptVoucherPage";
import ReportPaymentVoucherPage from "./view/report/ReportPaymentVoucherPage";
import ReportCashbillPage from "./view/report/ReportCashbillPage";
import ReportPettyCashPage from "./view/report/ReportPettyCashPage";
import ReportPartPriceComparePage from "./view/report/ReportPartPriceComparePage";
import ReportPriceComparePage from "./view/report/ReportPriceComparePage";
import ReportSSOPage from "./view/hr/sso/ReportSSOPage";
import ReportKKCProfit from "./view/report/ReportKKCProfit";
import ReportKKCPurchaseOrderSummary from "./view/report/ReportKKCPurchaseOrderSummary";
import PettyCashDoc from "./view/cashflow/PettyCashDoc";
import WorkJobControlPage from "./view/workdoc/jobcontrol/WorkJobControlPage";
import WorkJobOfficeControlPage from "./view/workdoc/officecontrol/WorkJobOfficeControlPage";
import RecheckControlPage from "./view/workdoc/recheckcontrol/RecheckControlPage";
import BackupCarRegistration from "./view/backupcar/BackupCarRegistration";
import BackupCarReservedButton from "./view/backupcar/BackupCarReservedButton";
// import CarPlan from './view/backupcar/plan/Plan'
// import CarTimeline from './view/backupcar/timeline/CarTimeline'
import CarPlan from "./view/backupcar/CarPlan";
import FixingOrderDoc from "./view/workdoc/jobcontrol/FixingOrderDoc";
import WorkTimeRecord from "./view/workdoc/jobcontrol/WorkTimeRecord";
import WorkDocGenForm from "./view/workdoc/WorkDocGenForm";
import WorkDocStock from "./view/workdoc/WorkDocStock";
import WorkDocInvoiceMenu from "./view/workdoc/WorkDocInvoiceMenu";
import PrintFixingOrderDoc from "./view/print/PrintFixingOrderDoc";
import PrintWorkJobPhoto from "./view/print/PrintWorkJobPhoto";
import PrintReportPOAndExpense from "./view/print/PrintReportPOAndExpense";
import PrintReportKKCAllYearProfit from "./view/print/PrintReportKKCAllYearProfit";
import PrintReportKKCAllYearIncomeOverview from "./view/print/PrintReportKKCAllYearIncomeOverview";
import PrintKKCTaxInvoiceCoverNote from "./view/print/PrintKKCTaxInvoiceCoverNote";
import PrintKKCTaxInvoiceCoverNoteInsurer from "./view/print/PrintKKCTaxInvoiceCoverNoteInsurer";
import PrintKKCBillingNoteCompany from "./view/print/PrintKKCBillingNoteCompany";
import PrintKKCBillingNoteInsurer from "./view/print/PrintKKCBillingNoteInsurer";
import PrintKKCDamagePartCheckList from "./view/print/PrintKKCDamagePartCheckList";
import PrintPurchaseReceivedDoc from "./view/print/PrintPurchaseReceivedDoc";
import PrintReceptionDoc from "./view/print/PrintReceptionDoc";
import PrintTwoPagesInvoiceDoc from "./view/print/PrintTwoPagesInvoiceDoc";
import PrintTwoPagesTaxInvoiceDoc from "./view/print/PrintTwoPagesTaxInvoiceDoc";
import PrintTwoPagesCashBillDoc from "./view/print/PrintTwoPagesCashBillDoc";
import PrintTwoPagesReceiptDoc from "./view/print/PrintTwoPagesReceiptDoc";
import PrintTwoPagesPurchaseOrderDoc from "./view/print/PrintTwoPagesPurchaseOrderDoc";
import PrintReportTJYIncentiveExpenseInsurance from "./view/print/PrintReportTJYIncentiveExpenseInsurance";
import PrintReportCashflowRecord from "./view/print/PrintReportCashflowRecord";
import PrintWCSParkingCarDoc from "./view/print/wcs/PrintWCSParkingCarDoc";
import PrintWCSCheckingCarDoc from "./view/print/wcs/PrintWCSCheckingCarDoc";
import PrintWCSFixingOrderDoc from "./view/print/wcs/PrintWCSFixingOrderDoc";
import PrintBHLParkingCarDoc from "./view/print/bhl/PrintBHLParkingCarDoc";
import PrintBHLFixingListOnCarDoc from "./view/print/bhl/PrintBHLFixingListOnCarDoc";
import PrintBNPInvoiceDoc from "./view/print/bnp/PrintBNPInvoiceDoc";
import PrintBNPTaxInvoiceDoc from "./view/print/bnp/PrintBNPTaxInvoiceDoc";
import PrintSSRInvoiceDoc from "./view/print/ssr/PrintSSRInvoiceDoc";
import PrintKKCPhotobook from "./view/print/PrintKKCPhotobook";
import PrintVoucherDoc from "./view/print/PrintVoucherDoc";
import PrintCreditDebitDoc from "./view/print/PrintCreditDebitDoc";
import PrintReportEmployee from "./view/print/PrintReportEmployee";
import PrintReportAnalysisBestJobcardProduct from "./view/print/statistics/PrintReportAnalysisBestJobcardProduct";
import PrintReportAnalysisBestPurchaseProduct from "./view/print/statistics/PrintReportAnalysisBestPurchaseProduct";
import PrintReportAnalysisBestPoShop from "./view/print/statistics/PrintReportAnalysisBestPoShop";
import PrintReportAnalysisBestJobcardService from "./view/print/statistics/PrintReportAnalysisBestJobcardService";
import PrintReportAnalysisBestJobcardBrand from "./view/print/statistics/PrintReportAnalysisBestJobcardBrand";
import PrintReportAnalysisBestJobcardInsurer from "./view/print/statistics/PrintReportAnalysisBestJobcardInsurer";
import PrintZongParkingCarDoc from "./view/print/zong/PrintZongParkingCarDoc";
import PrintZongBigJobDoc from "./view/print/zong/PrintZongBigJobDoc";
import PrintZongInvoiceDoc from "./view/print/zong/PrintZongInvoiceDoc";
import PrintZongTaxInvoiceCoverNoteInsurer from "./view/print/zong/PrintZongTaxInvoiceCoverNoteInsurer";
import PrintORCFixingOrderDoc from "./view/print/orc/PrintORCFixingOrderDoc";
import PrintReportStockListInOut from "./view/print/stock/PrintReportStockListInOut";
// import ReportContractor from './view/report/ReportContractor'
import InsurerPageModal from "./view/insurer/InsurerPageModal";
import InsurerPage from "./view/insurer/InsurerPage";
import SupplierPageModal from "./view/po/SupplierPageModal";
// import SupplierPage from './view/po/SupplierPage'
import SelectParts from "./view/po/SelectParts";
import WorkJobTimeTable from "./view/workdoc/jobcontrol/WorkJobTimeTable";
import PMBoardTable from "./view/workdoc/pmcontrol/PMBoardTable";
import ReportPage from "./view/report/ReportPage";
import ReportCategoryPage from "./view/report/ReportCategoryPage";
import TutorialPage from "./view/tutorial/TutorialPage";
import WorkDocPurchaseOrder from "./view/workdoc/WorkDocPurchaseOrder";
import WorkDocAttachmentDoc from "./view/workdoc/WorkDocAttachmentDoc";
import WorkDocTimeline from "./view/workdoc/WorkDocTimeline";
import WorkDocMessage from "./view/workdoc/WorkDocMessage";
// import MyPlan from './view/workdoc/plan/MyPlan'
import TestPlan from "./view/workdoc/plan/TestPlan";
import StockManagementPage from "./view/stock/StockManagementPage";
import StockTyreManagementPage from "./view/tyre/stock/StockTyreManagementPage";
import StockPainterBorrowingRecord from "./view/stock/StockPainterBorrowingRecord";
import StockToolBorrowingRecord from "./view/stock/StockToolBorrowingRecord";
import StockProductUsageRecord from "./view/stock/StockProductUsageRecord";
import StockSpecification from "./view/stock/StockSpecification";
import CashFlowRecord from "./view/cashflow/CashFlowRecord";
import IncentiveExpenseRecord from "./view/cashflow/IncentiveExpenseRecord";
// import IncentivePayeeButton from './view/cashflow/IncentivePayeeButton'
import StockMixPaintReport from "./view/stock/StockMixPaintReport";
import StockRequestReport from "./view/stock/StockRequestReport";
import StockRequestDoc from "./view/stock/StockRequestDoc";
import StockAnyExportReport from "./view/stock/StockAnyExportReport";
import PrintPreview from "./view/print/PrintPreview";
import PrintReportJobControlBoard from "./view/print/PrintReportJobControlBoard";
import PrintParkingCarDoc from "./view/print/PrintParkingCarDoc";
import PrintQuotationDoc from "./view/print/PrintQuotationDoc";
import PrintQuotationDoc2 from "./view/print/PrintQuotationDoc2";
import PrintExcelQuotationDoc from "view/print/kkc/PrintExcelQuotationDoc";
import PrintWorkJobTimeTable from "./view/print/PrintWorkJobTimeTable";
import PrintWorkOfficeJobTimeTable from "./view/print/PrintWorkOfficeJobTimeTable";
import PrintSSTWorkCoverFileDoc from "./view/print/sst/PrintSSTWorkCoverFileDoc";
import PrintSSTFixingListOnCarDoc from "./view/print/sst/PrintSSTFixingListOnCarDoc";
import PrintCheckingDamageDoc from "./view/print/PrintCheckingDamageDoc";
import PrintSSTParkingCarDoc from "./view/print/sst/PrintSSTParkingCarDoc";
import PrintSSTWarrantyWorkDoc from "./view/print/sst/PrintSSTWarrantyWorkDoc";
import PrintTNKBigJobDoc from "./view/print/tnk/PrintTNKBigJobDoc";
import PrintSSTBigJobDoc from "./view/print/sst/PrintSSTBigJobDoc";
import PrintSSTBillingNoteInsurer from "./view/print/sst/PrintSSTBillingNoteInsurer";
import PrintShippingLabel from "./view/print/PrintShippingLabel";
import PrintTLGTaxInvoiceCoverNoteInsurer from "./view/print/tlg/PrintTLGTaxInvoiceCoverNoteInsurer";
import PrintTLGInvoiceDoc from "./view/print/tlg/PrintTLGInvoiceDoc";
import PrintSSTTaxInvoiceCoverNoteInsurer from "./view/print/sst/PrintSSTTaxInvoiceCoverNoteInsurer";
import PrintTJYSalarySlipDoc from "./view/print/PrintTJYSalarySlipDoc";
import PrintReportStockCheck from "./view/print/PrintReportStockCheck";
import PrintCarSummaryDoc from "./view/print/PrintCarSummaryDoc";
import PrintNDMFixingListOnCarDoc from "./view/print/ndm/PrintNDMFixingListOnCarDoc";
import PrintKKCContractorQuotationDoc from "./view/print/PrintKKCContractorQuotationDoc";
import PrintReportContractorWageTable from "./view/print/PrintReportContractorWageTable";
import PrintReportContractorWageSlip from "./view/print/PrintReportContractorWageSlip";
import PrintSlipContractorDetail from "./view/print/PrintSlipContractorDetail";
import PrintReportSummarySlip from "./view/print/PrintReportSummarySlip";
import PrintReportKKCIncome from "./view/print/PrintReportKKCIncome";
import PrintReportKKCBalance from "./view/print/PrintReportKKCBalance";
import PrintReportKKCReceivableCash from "./view/print/PrintReportKKCReceivableCash";
import PrintReportKKCBillingNoteReceivable from "./view/print/PrintReportKKCBillingNoteReceivable";
import PrintReportKKCPurchaseOrderSummary from "./view/print/PrintReportKKCPurchaseOrderSummary";
import PrintWorkQCDoc from "./view/print/PrintWorkQCDoc";
import PrintKKCWorkQCDoc from "./view/print/PrintKKCWorkQCDoc";
import PrintTNKWorkCoverFileDoc from "./view/print/tnk/PrintTNKWorkCoverFileDoc";
import PrintReportPickup from "./view/print/PrintReportPickup";
import PrintReportCommissionMechanic from "./view/print/employee/PrintReportCommissionMechanic";
import PrintReportWorking from "./view/print/employee/PrintReportWorking";
import PrintReportWork from "./view/print/PrintReportWork";
import PrintReportWorkingDetail from "./view/print/employee/PrintReportWorkingDetail";
import PrintReportProductTransactionImport from "./view/print/stock/PrintReportProductTransactionImport";
import PrintReportProductTransactionRequestPurchase from "./view/print/stock/PrintReportProductTransactionRequestPurchase";
import PrintReportProductBalance from "./view/print/stock/PrintReportProductBalance";
import PrintReportStockBalanceValue from "./view/print/stock/PrintReportStockBalanceValue";
import PrintReportStockCard from "./view/print/stock/PrintReportStockCard";
import PrintReportStockCardCost from "./view/print/stock/PrintReportStockCardCost";
import PrintReportStockFixingCar from "./view/print/stock/PrintReportStockFixingCar";
import PrintReportPOReceivedProduct from "./view/print/po/PrintReportPOReceivedProduct";
import PrintReportSalesTax from "./view/print/finance/PrintReportSalesTax";
import PrintReportPostPayment from "./view/print/finance/PrintReportPostPayment";
import PrintReportAccountReceiable from "./view/print/finance/PrintReportAccountReceiable";
import PrintReportAccountReceiableDetail from "./view/print/finance/PrintReportAccountReceiableDetail";
import PrintReportSummaryFixingWork from "./view/print/fixing/PrintReportSummaryFixingWork";
import PrintReportFixingRefixed from "./view/print/fixing/PrintReportFixingRefixed";
import PrintReportUnfinishedWork from "./view/print/fixing/PrintReportUnfinishedWork";
import PrintReportUnfinishedWorkDetail from "./view/print/fixing/PrintReportUnfinishedWorkDetail";
import PrintReportPostponeAppointment from "./view/print/fixing/PrintReportPostponeAppointment";
import PrintReportWaitingQuotation from "./view/print/fixing/PrintReportWaitingQuotation";
import PrintReportSummaryWork from "./view/print/analysis/PrintReportSummaryWork";
import PrintReportSummaryWorkDetail from "./view/print/analysis/PrintReportSummaryWorkDetail";
import PrintReportAnalysisInOutWork from "./view/print/analysis/PrintReportAnalysisInOutWork";
import PrintReportAnalysisWorkCustomCost from "./view/print/analysis/PrintReportAnalysisWorkCustomCost";
import PrintReportAnalysisDeliveryEfficiency from "./view/print/analysis/PrintReportAnalysisDeliveryEfficiency";
import PrintReportWorkDocPurchaseOrder from "./view/print/PrintReportWorkDocPurchaseOrder";
import PrintReportSummaryOT from "./view/print/hr/PrintReportSummaryOT";
import PrintReportSummaryNormalAbsence from "./view/print/hr/PrintReportSummaryNormalAbsence";
import PrintReportSummaryDeductionAbsence from "./view/print/hr/PrintReportSummaryDeductionAbsence";
import PrintSlipTableDoc from "./view/print/hr/PrintSlipTableDoc";
import PrintReportConsumablesMaterial from "./view/print/material/PrintReportConsumablesMaterial";
import PrintReportColor from "./view/print/material/PrintReportColor";
import PrintReportColorDetail from "./view/print/material/PrintReportColorDetail";
import PrintReportBalanceMaterial from "./view/print/material/PrintReportBalanceMaterial";
import PrintReportStockMixPaint from "./view/print/material/PrintReportStockMixPaint";
import PrintReportUsageVolumeTransactionRecord from "./view/print/material/PrintReportUsageVolumeTransactionRecord";
import PrintReportStockCardVolume from "./view/print/material/PrintReportStockCardVolume";
import PrintReportJobCostSheet from "./view/print/analysis/PrintReportJobCostSheet";
import PrintReportAnalysisWorkDebitCreditInOut from "./view/print/analysis/PrintReportAnalysisWorkDebitCreditInOut";
import PrintReportJobCostSheetDetail from "./view/print/analysis/PrintReportJobCostSheetDetail";
import PrintReportQuotationMovement from "./view/print/analysis/PrintReportQuotationMovement";
import PrintReportOutstandingIncomeSummary from "./view/print/analysis/PrintReportOutstandingIncomeSummary";
import PrintReportOutstandingIncomeSummaryDetail from "./view/print/analysis/PrintReportOutstandingIncomeSummaryDetail";
import PrintContinuousPaperConfig from "./view/print/paperconfig/PrintContinuousPaperConfig";
import PdfContinuousPaper from "./view/print/paperconfig/PdfContinuousPaper";
import PrintReportSummaryInsure from "./view/print/analysis/PrintReportSummaryInsure";
import PrintReportSummaryDetailInsure from "./view/print/analysis/PrintReportSummaryDetailInsure";
import PrintPaymentNoteDoc from "./view/print/PrintPaymentNoteDoc";
import PrintGeneralSlipDoc from "./view/print/PrintGeneralSlipDoc";
// import PrintReportMechanicWork from './view/print/PrintReportMechanicWork'
import PrintSSTWorkQCDoc from "./view/print/sst/PrintSSTWorkQCDoc";
import PrintPGAAppointmentQueueDoc from "./view/print/pga/PrintPGAAppointmentQueueDoc";
import PrintPGAWorkCoverFileDoc from "./view/print/pga/PrintPGAWorkCoverFileDoc";
import PrintPGABorrowingBackupcarDoc from "./view/print/pga/PrintPGABorrowingBackupcarDoc";
import SWTNewColorButton from "./view/workdoc/SWTNewColorButton";
import SWTNewInsurerButton from "./view/workdoc/SWTNewInsurerButton";
import EmployeeCodeButton from "./view/hr/EmployeeCodeButton";
import Tracker from "./view/workdoc/qrtracker/Tracker";
import WorkTracker from "./view/workdoc/qrtracker/WorkTracker";
import MainDashboard from "./view/dashboard/MainDashboard";
import QuotationFileTreePage from "./view/qo/QuotationFileTreePage";
import SWTWorkUpload from "./view/workdoc/SWTWorkUpload";
import CarDamageContainer from "./view/workdoc/CarDamageContainer";
import CarDamageDebug from "view/debug/CarDamageDebug";
import PartItemTable from "./view/book/PartItemTable";
import NewWageItemModal from "./component/element/CarDamageForm/NewWageItemModal/NewWageItemModal";
import NewPartItemModal from "./component/element/CarDamageForm/NewPartItemModal/NewPartItemModal";
import DatePickerModal from "./component/element/DatePickerModal";
// import RemarkRecordModal from './component/element/RemarkRecordModal';
import "./index.css";
import "icheck/skins/all.css";
import "react-select/dist/react-select.css";
import "bootstrap/dist/css/bootstrap.css";
import "./asset/css/bf.css";
import AccountSettings from "./view/settings/AccountSettings";
import MessageNoti from "./view/menu/MessageNoti";
import RealtimeDebug from "./view/debug/RealtimeDebug";
import AdminConfig from "view/debug/AdminConfig";
import PermissionTable from "view/permission/PermissionTable";
//import 'bootstrap/dist/css/bootstrap-theme.css';
import TermOfServiceModal from "./view/tos/TermOfServiceModal";
import NotificationScheduleConfig from "./view/notification/NotificationScheduleConfig";
import Calendar from "view/calendar/Calendar";
import FixLevelConfig from "./view/workdoc/fixlevel/FixLevelConfig";
import FixCommissionConfig from "./view/workdoc/fixlevel/FixCommissionConfig";
import WorkPostponeAppointmentButton from "./view/workdoc/WorkPostponeAppointmentButton";
import ConfigOfficeWorkflow from "./view/admin/ConfigOfficeWorkflow";
import ConfigMechanicWorkflow from "./view/admin/ConfigMechanicWorkflow";
import DetectOffline from "view/notification/DetectOffline";
import ReportTyreRepairPage from "./view/tyre/ReportTyreRepairPage";
import ReportTyreRetirePage from "./view/tyre/ReportTyreRetirePage";
import ReportTyreRepairInsidePage from "./view/tyre/ReportTyreRepairInsidePage";
import ReportTyreReceptionPage from "./view/tyre/ReportTyreReceptionPage";
import ReportTyreVehicleRegistrationPage from "./view/tyre/ReportTyreVehicleRegistrationPage";
import ReportAllTyreRepairPage from "./view/tyre/ReportAllTyreRepairPage";
import ReportAssetVehiclePage from "./view/tyre/report-asset-vehicle-page/ReportAssetVehiclePage";
import PrintTyreRepairDoc from "./view/print/tyre/PrintTyreRepairDoc";
import PrintTyreRetireDoc from "./view/print/tyre/PrintTyreRetireDoc";
import PreviewWorkDoc from "./view/workdoc/preview/PreviewWorkDoc";
import LineMessagePage from "./view/linemessage/LineMessagePage";
import SWTCreditInstallment from "./view/workdoc/SWTCreditInstallment";
import EmployeeWorkMonthlyReport from "./view/hr/EmployeeWorkMonthlyReport";
import PrintEmployeeWorkMonthlyReport from "./view/print/hr/PrintEmployeeWorkMonthlyReport";
import reduxMiddleware from "react-block-ui/reduxMiddleware";
import ReportAllAssetPage from "./view/asset/ReportAllAssetPage";
import AssetDoc from "./view/asset/AssetDoc";
import AssetVehicleDoc from "./view/tyre/report-asset-vehicle-page/AssetVehicleDoc";
import ScheduledServicePlan from "./view/ssp/ScheduledServicePlan";
import ReportAppointmentReturn from "view/backupcar/ReportAppointmentReturn";
import PrintDearTaxInvoiceDoc from "view/print/dear/PrintDearTaxInvoiceDoc";
import PrintDearPartDisposebyReturn from "view/print/dear/PrintDearPartDisposebyReturn";
import PrintDeliveryCarDoc from "view/print/PrintDeliveryCarDoc";
import ReportAnalysisWorkCustomCost from "view/report/analysis/ReportAnalysisWorkCustomCost";

const Provider = require("react-redux").Provider;
const createStore = require("redux").createStore;
const applyMiddleware = require("redux").applyMiddleware;
const content = require("./reducer");
const store = createStore(content, applyMiddleware(reduxMiddleware));

export function renderReactDOM(component, element) {
  // return ReactDOM.render(
  //   <Provider {... { store }}>{component}</Provider>,
  //   element
  // );
  return ReactDOM.render(
    <Provider {...{ store }}>
      <App>{component}</App>
    </Provider>,
    element
  );
}

export function handlePage(urlParams) {
  switch (urlParams["startPage"]) {
    case "DetectOffline":
      ReactDOM.render(<DetectOffline />, document.getElementById("root"));
      break;
    case "OrganizationSelectionModal":
      ReactDOM.render(
        <OrganizationSelectionModal show={true} />,
        document.getElementById("root")
      );
      break;
    case "FAQManagementPage":
      renderReactDOM(
        <HashRouter>
          <FAQManagementPage />
        </HashRouter>,
        document.getElementById("root")
      );
      break;
    case "PettyCashDoc":
      ReactDOM.render(<PettyCashDoc />, document.getElementById("root"));
      break;
    case "Calendar":
      ReactDOM.render(<Calendar />, document.getElementById("root"));
      break;
    case "FixLevelConfig":
      ReactDOM.render(<FixLevelConfig />, document.getElementById("root"));
      break;
    case "FixCommissionConfig":
      ReactDOM.render(<FixCommissionConfig />, document.getElementById("root"));
      break;
    case "WorkPostponeAppointmentButton":
      ReactDOM.render(
        <WorkPostponeAppointmentButton workNo={urlParams["wo"]} />,
        document.getElementById("root")
      );
      break;
    case "ConfigOfficeWorkflow":
      ReactDOM.render(
        <ConfigOfficeWorkflow workNo={urlParams["wo"]} />,
        document.getElementById("root")
      );
      break;
    case "ConfigMechanicWorkflow":
      ReactDOM.render(
        <ConfigMechanicWorkflow workNo={urlParams["wo"]} />,
        document.getElementById("root")
      );
      break;
    case "SlipEditPopup":
      ReactDOM.render(
        <SlipEditPopup slipId={"PA00021"} />,
        document.getElementById("root")
      );
      break;
    case "SWTCustomerPage":
      renderReactDOM(<SWTCustomerPage />, document.getElementById("root"));
      break;
    case "SWTCreditInstallment": {
      let childInst = null;
      renderReactDOM(
        <SWTCreditInstallment
          onRef={(ref) => {
            childInst = ref;
            childInst.loadData(urlParams["wo"]);
          }}
          workNo={urlParams["wo"]}
          amount={80000}
        />,
        document.getElementById("root")
      );

      break;
    }
    case "InsurerPage":
      ReactDOM.render(<InsurerPage />, document.getElementById("root"));
      break;
    case "EmployeeWorkMonthlyReport":
      ReactDOM.render(
        <EmployeeWorkMonthlyReport em={urlParams["em"]} />,
        document.getElementById("root")
      );
      break;
    case "PrintEmployeeWorkMonthlyReport":
      ReactDOM.render(
        <PrintEmployeeWorkMonthlyReport
          year={urlParams["year"]}
          month={urlParams["month"]}
          em={urlParams["em"]}
          showBar={urlParams["show_bar"]}
        />,
        document.getElementById("root")
      );
      break;
    case "SWTNewCarButton":
      ReactDOM.render(<SWTNewCarButton />, document.getElementById("root"));
      break;
    case "SWTNewCarTypeButton":
      ReactDOM.render(<SWTNewCarTypeButton />, document.getElementById("root"));
      break;
    case "SWTWorkDocDamage":
      renderReactDOM(
        <SWTWorkDocDamage workNo={urlParams["wo"]} />,
        document.getElementById("root")
      );
      break;
    case "RCKWorkDocDamage":
      renderReactDOM(
        <HashRouter>
          <RCKWorkDocDamage workNo={urlParams["wo"]} />
        </HashRouter>,
        document.getElementById("root")
      );
      break;
    case "SWTWorkDocDamageFasttrack":
      renderReactDOM(
        <HashRouter>
          <SWTWorkDocDamageFasttrack workNo={urlParams["wo"]} />
        </HashRouter>,
        document.getElementById("root")
      );
      break;
    case "SlipDailyEmployeeTable":
      renderReactDOM(
        <SlipDailyEmployeeTable emType="daily" />,
        document.getElementById("root")
      );
      break;
    case "SlipMonthlyEmployeeTable":
      renderReactDOM(
        <SlipDailyEmployeeTable emType="monthly" />,
        document.getElementById("root")
      );
      break;
    case "SlipContractorTable":
      ReactDOM.render(<SlipContractorTable />, document.getElementById("root"));
      break;
    case "ReportContractorWage":
      ReactDOM.render(
        <ReportContractorWage />,
        document.getElementById("root")
      );
      break;
    case "ReportWithholdingTaxPage":
      renderReactDOM(
        <ReportWithholdingTaxPage />,
        document.getElementById("root")
      );
      break;
    case "ReportFixingOrderPage":
      renderReactDOM(
        <ReportFixingOrderPage />,
        document.getElementById("root")
      );
      break;
    case "ExcelEmployeeWage":
      ReactDOM.render(<ExcelEmployeeWage />, document.getElementById("root"));
      break;
    case "ReportPendingWork":
      ReactDOM.render(<ReportPendingWork />, document.getElementById("root"));
      break;
    case "ReportInvoice":
      ReactDOM.render(
        <ReportInvoice title="ใบกำกับภาษี" requestPath="/report/invoiceTax" />,
        document.getElementById("root")
      );
      break;
    case "ReportQuotationPage":
      renderReactDOM(<ReportQuotationPage />, document.getElementById("root"));
      break;
    case "ReportInvoicePage":
      renderReactDOM(<ReportInvoicePage />, document.getElementById("root"));
      break;
    case "ReportReceiptPage":
      renderReactDOM(<ReportReceiptPage />, document.getElementById("root"));
      break;
    case "ReportTaxinvoicePage":
      renderReactDOM(<ReportTaxinvoicePage />, document.getElementById("root"));
      break;
    case "ReportCreditNotePage":
      renderReactDOM(
        <HashRouter>
          <ReportCreditNotePage />
        </HashRouter>,
        document.getElementById("root")
      );
      break;
    case "ReportDebitNotePage":
      renderReactDOM(
        <HashRouter>
          <ReportDebitNotePage />
        </HashRouter>,
        document.getElementById("root")
      );
      break;
    case "ReportSSOPage":
      renderReactDOM(
        <HashRouter>
          <ReportSSOPage />
        </HashRouter>,
        document.getElementById("root")
      );
      break;
    case "ReportBillingNotePage":
      renderReactDOM(
        <HashRouter>
          <ReportBillingNotePage />
        </HashRouter>,
        document.getElementById("root")
      );
      break;
    case "ReportReceptionPage":
      renderReactDOM(
        <HashRouter>
          <ReportReceptionPage {...urlParams} />
        </HashRouter>,
        document.getElementById("root")
      );
      break;
    case "ReportReceiptVoucherPage":
      renderReactDOM(
        <HashRouter>
          <ReportReceiptVoucherPage />
        </HashRouter>,
        document.getElementById("root")
      );
      break;
    case "ReportPaymentVoucherPage":
      renderReactDOM(
        <HashRouter>
          <ReportPaymentVoucherPage />
        </HashRouter>,
        document.getElementById("root")
      );
      break;
    case "ReportCashbillPage":
      renderReactDOM(<ReportCashbillPage />, document.getElementById("root"));
      break;
    case "ReportKKCProfit":
      ReactDOM.render(<ReportKKCProfit />, document.getElementById("root"));
      break;
    case "ReportKKCPurchaseOrderSummary":
      ReactDOM.render(
        <ReportKKCPurchaseOrderSummary />,
        document.getElementById("root")
      );
      break;
    case "PrintReportKKCPurchaseOrderSummary":
      ReactDOM.render(
        <PrintReportKKCPurchaseOrderSummary
          year={urlParams["year"]}
          month={urlParams["month"]}
          credit={urlParams["credit"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintWorkQCDoc":
      ReactDOM.render(
        <PrintWorkQCDoc workNo={urlParams["wo"]} />,
        document.getElementById("root")
      );
      break;
    case "PrintKKCWorkQCDoc":
      ReactDOM.render(
        <PrintKKCWorkQCDoc workNo={urlParams["wo"]} />,
        document.getElementById("root")
      );
      break;
    case "PrintTNKWorkCoverFileDoc":
      ReactDOM.render(
        <PrintTNKWorkCoverFileDoc workNo={urlParams["wo"]} />,
        document.getElementById("root")
      );
      break;
    case "PrintReportPickup":
      ReactDOM.render(
        <PrintReportPickup
          year={urlParams["year"]}
          month={urlParams["month"]}
          name={decodeURIComponent(urlParams["name"])}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportCommissionMechanic":
      ReactDOM.render(
        <PrintReportCommissionMechanic
          year={urlParams["year"]}
          month={urlParams["month"]}
          day={urlParams["day"]}
          empId={urlParams["empId"]}
          isRange={urlParams["isRange"]}
          startDate={urlParams["start_date"]}
          endDate={urlParams["end_date"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportWork":
      renderReactDOM(
        <PrintReportWork {...urlParams} />,
        document.getElementById("root")
      );
      break;
    case "PrintReportWorking":
      ReactDOM.render(
        <PrintReportWorking
          year={urlParams["year"]}
          month={urlParams["month"]}
          type={urlParams["type"]}
          isRange={urlParams["isRange"]}
          startDate={urlParams["start_date"]}
          endDate={urlParams["end_date"]}
          fullname={decodeURIComponent(urlParams["fullname"])}
          taskclosed={urlParams["taskclosed"]}
          taskamount={urlParams["taskamount"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportWorkingDetail":
      ReactDOM.render(
        <PrintReportWorkingDetail
          year={urlParams["year"]}
          month={urlParams["month"]}
          empId={urlParams["empId"]}
          type={urlParams["type"]}
          taskValue={urlParams["taskValue"]}
          fullname={decodeURIComponent(urlParams["fullname"])}
          taskclosed={decodeURIComponent(urlParams["taskclosed"])}
          taskamount={urlParams["taskamount"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportProductTransactionImport":
      ReactDOM.render(
        <PrintReportProductTransactionImport
          year={urlParams["year"]}
          month={urlParams["month"]}
          day={urlParams["day"]}
          groupId={urlParams["groupId"]}
          recordType={urlParams["recordType"]}
          isRange={urlParams["isRange"]}
          startDate={urlParams["start_date"]}
          endDate={urlParams["end_date"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportProductTransactionRequestPurchase":
      ReactDOM.render(
        <PrintReportProductTransactionRequestPurchase
          year={urlParams["year"]}
          month={urlParams["month"]}
          day={urlParams["day"]}
          groupId={urlParams["groupId"]}
          recordType={urlParams["recordType"]}
          isRange={urlParams["isRange"]}
          startDate={urlParams["start_date"]}
          endDate={urlParams["end_date"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportProductBalance":
      ReactDOM.render(
        <PrintReportProductBalance
          year={urlParams["year"]}
          month={urlParams["month"]}
          day={urlParams["day"]}
          groupId={urlParams["groupId"]}
          isRange={urlParams["isRange"]}
          startDate={urlParams["start_date"]}
          endDate={urlParams["end_date"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportStockBalanceValue":
      ReactDOM.render(
        <PrintReportStockBalanceValue
          stockType={urlParams["stock_type"]}
          catId={urlParams["cat_id"]}
          subCatId={urlParams["sub_cat_id"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportStockCard":
      ReactDOM.render(
        <PrintReportStockCard
          year={urlParams["year"]}
          month={urlParams["month"]}
          day={urlParams["day"]}
          isRange={urlParams["isRange"]}
          startDate={urlParams["start_date"]}
          endDate={urlParams["end_date"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportStockCardCost":
      renderReactDOM(
        <PrintReportStockCardCost
          year={urlParams["year"]}
          month={urlParams["month"]}
          day={urlParams["day"]}
          cat_id={urlParams["cat_id"]}
          itemnum={urlParams["itemnum"]}
          isRange={urlParams["isRange"]}
          startDate={urlParams["start_date"]}
          endDate={urlParams["end_date"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportStockCheck":
      renderReactDOM(
        <PrintReportStockCheck stockType={urlParams["type"]} />,
        document.getElementById("root")
      );
      break;
    case "PrintReportStockFixingCar":
      renderReactDOM(
        <PrintReportStockFixingCar
          year={urlParams["year"]}
          month={urlParams["month"]}
          day={urlParams["day"]}
          searchBy={urlParams["search_by"]}
          query={urlParams["query"]}
          isRange={urlParams["isRange"]}
          startDate={urlParams["start_date"]}
          endDate={urlParams["end_date"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportStockCardVolume":
      ReactDOM.render(
        <PrintReportStockCardVolume
          year={urlParams["year"]}
          month={urlParams["month"]}
          day={urlParams["day"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportPOReceivedProduct":
      ReactDOM.render(
        <PrintReportPOReceivedProduct
          year={urlParams["year"]}
          month={urlParams["month"]}
          day={urlParams["day"]}
          shopId={urlParams["shopId"]}
          isRange={urlParams["isRange"]}
          startDate={urlParams["start_date"]}
          endDate={urlParams["end_date"]}
          type={urlParams["type"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportSalesTax":
      ReactDOM.render(
        <PrintReportSalesTax
          year={urlParams["year"]}
          month={urlParams["month"]}
          day={urlParams["day"]}
          name={decodeURIComponent(urlParams["name"])}
          isRange={urlParams["isRange"]}
          startDate={urlParams["start_date"]}
          endDate={urlParams["end_date"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportPostPayment":
      ReactDOM.render(
        <PrintReportPostPayment
          year={urlParams["year"]}
          month={urlParams["month"]}
          day={urlParams["day"]}
          name={decodeURIComponent(urlParams["name"])}
          isRange={urlParams["isRange"]}
          startDate={urlParams["start_date"]}
          endDate={urlParams["end_date"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportAccountReceiable":
      ReactDOM.render(
        <PrintReportAccountReceiable
          year={urlParams["year"]}
          month={urlParams["month"]}
          day={urlParams["day"]}
          customerType={urlParams["customerType"]}
          isRange={urlParams["isRange"]}
          startDate={urlParams["start_date"]}
          endDate={urlParams["end_date"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportAccountReceiableDetail":
      ReactDOM.render(
        <PrintReportAccountReceiableDetail
          year={urlParams["year"]}
          month={urlParams["month"]}
          day={urlParams["day"]}
          customerType={urlParams["customerType"]}
          type={urlParams["type"]}
          isRange={urlParams["isRange"]}
          startDate={urlParams["start_date"]}
          endDate={urlParams["end_date"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportSummaryFixingWork":
      ReactDOM.render(
        <PrintReportSummaryFixingWork
          year={urlParams["year"]}
          month={urlParams["month"]}
          day={urlParams["day"]}
          isRange={urlParams["isRange"]}
          startDate={urlParams["start_date"]}
          endDate={urlParams["end_date"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportFixingRefixed":
      ReactDOM.render(
        <PrintReportFixingRefixed
          year={urlParams["year"]}
          month={urlParams["month"]}
          day={urlParams["day"]}
          isRange={urlParams["isRange"]}
          startDate={urlParams["start_date"]}
          endDate={urlParams["end_date"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportUnfinishedWork":
      ReactDOM.render(
        <PrintReportUnfinishedWork />,
        document.getElementById("root")
      );
      break;
    case "PrintReportUnfinishedWorkDetail":
      ReactDOM.render(
        <PrintReportUnfinishedWorkDetail
          paymentType={urlParams["paymentType"]}
          startDay={urlParams["startDay"]}
          endDay={urlParams["endDay"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportPostponeAppointment":
      ReactDOM.render(
        <PrintReportPostponeAppointment
          year={urlParams["year"]}
          month={urlParams["month"]}
          day={urlParams["day"]}
          isRange={urlParams["isRange"]}
          startDate={urlParams["start_date"]}
          endDate={urlParams["end_date"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportSummaryWork":
      ReactDOM.render(
        <PrintReportSummaryWork
          year={urlParams["year"]}
          month={urlParams["month"]}
          day={urlParams["day"]}
          isRange={urlParams["isRange"]}
          startDate={urlParams["start_date"]}
          endDate={urlParams["end_date"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportSummaryWorkDetail":
      ReactDOM.render(
        <PrintReportSummaryWorkDetail
          year={urlParams["year"]}
          month={urlParams["month"]}
          day={urlParams["day"]}
          type={urlParams["type"]}
          paymentType={urlParams["paymentType"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportAnalysisInOutWork":
      ReactDOM.render(
        <PrintReportAnalysisInOutWork
          year={urlParams["year"]}
          month={urlParams["month"]}
          day={urlParams["day"]}
          isRange={urlParams["isRange"]}
          startDate={urlParams["start_date"]}
          endDate={urlParams["end_date"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportAnalysisWorkCustomCost":
      ReactDOM.render(
        <PrintReportAnalysisWorkCustomCost
          year={urlParams["year"]}
          month={urlParams["month"]}
          day={urlParams["day"]}
          isRange={urlParams["isRange"]}
          startDate={urlParams["start_date"]}
          endDate={urlParams["end_date"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportAnalysisDeliveryEfficiency":
      ReactDOM.render(
        <PrintReportAnalysisDeliveryEfficiency
          year={urlParams["year"]}
          month={urlParams["month"]}
          day={urlParams["day"]}
          isRange={urlParams["isRange"]}
          startDate={urlParams["start_date"]}
          endDate={urlParams["end_date"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportWaitingQuotation":
      ReactDOM.render(
        <PrintReportWaitingQuotation
          customerType={urlParams["customerType"]}
          q={decodeURIComponent(urlParams["q"])}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportWorkDocPurchaseOrder":
      renderReactDOM(
        <PrintReportWorkDocPurchaseOrder workNo={urlParams["wo"]} />,
        document.getElementById("root")
      );
      break;
    case "PrintReportSummaryOT":
      ReactDOM.render(
        <PrintReportSummaryOT
          year={urlParams["year"]}
          month={urlParams["month"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportSummaryNormalAbsence":
      ReactDOM.render(
        <PrintReportSummaryNormalAbsence
          year={urlParams["year"]}
          month={urlParams["month"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportSummaryDeductionAbsence":
      ReactDOM.render(
        <PrintReportSummaryDeductionAbsence
          year={urlParams["year"]}
          month={urlParams["month"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintSlipTableDoc":
      ReactDOM.render(
        <PrintSlipTableDoc
          year={urlParams["year"]}
          month={urlParams["month"]}
          emType={urlParams["emType"]}
          resulttype={urlParams["resulttype"]}
          value={urlParams["value"]}
          start={urlParams["start"]}
          end={urlParams["end"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportConsumablesMaterial":
      ReactDOM.render(
        <PrintReportConsumablesMaterial
          year={urlParams["year"]}
          month={urlParams["month"]}
          day={urlParams["day"]}
          groupId={urlParams["groupId"]}
          isRange={urlParams["isRange"]}
          startDate={urlParams["start_date"]}
          endDate={urlParams["end_date"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportColor":
      ReactDOM.render(
        <PrintReportColor
          year={urlParams["year"]}
          month={urlParams["month"]}
          day={urlParams["day"]}
          isRange={urlParams["isRange"]}
          startDate={urlParams["start_date"]}
          endDate={urlParams["end_date"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportColorDetail":
      ReactDOM.render(
        <PrintReportColorDetail
          year={urlParams["year"]}
          month={urlParams["month"]}
          day={urlParams["day"]}
          description={decodeURIComponent(urlParams["description"])}
          productcode={urlParams["productcode"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportBalanceMaterial":
      ReactDOM.render(
        <PrintReportBalanceMaterial groupId={urlParams["groupId"]} />,
        document.getElementById("root")
      );
      break;
    case "PrintReportStockMixPaint":
      ReactDOM.render(
        <PrintReportStockMixPaint
          year={urlParams["year"]}
          month={urlParams["month"]}
          day={urlParams["day"]}
          isRange={urlParams["isRange"]}
          startDate={urlParams["start_date"]}
          endDate={urlParams["end_date"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportUsageVolumeTransactionRecord":
      ReactDOM.render(
        <PrintReportUsageVolumeTransactionRecord
          year={urlParams["year"]}
          month={urlParams["month"]}
          day={urlParams["day"]}
          isRange={urlParams["isRange"]}
          startDate={urlParams["start_date"]}
          endDate={urlParams["end_date"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportJobCostSheet":
      ReactDOM.render(
        <PrintReportJobCostSheet
          year={urlParams["year"]}
          month={urlParams["month"]}
          day={urlParams["day"]}
          isRange={urlParams["isRange"]}
          startDate={urlParams["start_date"]}
          endDate={urlParams["end_date"]}
          criterion={urlParams["criterion"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportAnalysisWorkDebitCreditInOut":
      ReactDOM.render(
        <PrintReportAnalysisWorkDebitCreditInOut
          year={urlParams["year"]}
          month={urlParams["month"]}
          day={urlParams["day"]}
          isRange={urlParams["isRange"]}
          startDate={urlParams["start_date"]}
          endDate={urlParams["end_date"]}
          criterion={urlParams["criterion"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportJobCostSheetDetail":
      ReactDOM.render(
        <PrintReportJobCostSheetDetail
          type={urlParams["type"]}
          workNo={urlParams["wo"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportQuotationMovement":
      ReactDOM.render(
        <PrintReportQuotationMovement
          year={urlParams["year"]}
          month={urlParams["month"]}
          day={urlParams["day"]}
          isRange={urlParams["isRange"]}
          startDate={urlParams["start_date"]}
          endDate={urlParams["end_date"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportOutstandingIncomeSummary":
      ReactDOM.render(
        <PrintReportOutstandingIncomeSummary />,
        document.getElementById("root")
      );
      break;
    case "PrintReportOutstandingIncomeSummaryDetail":
      ReactDOM.render(
        <PrintReportOutstandingIncomeSummaryDetail
          type={urlParams["type"]}
          insurerId={urlParams["insurerId"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportSummary":
      ReactDOM.render(
        <PrintReportSummaryInsure
          viewForm={urlParams["viewForm"]}
          type={urlParams["type"]}
          year={urlParams["year"]}
          month={urlParams["month"]}
          day={urlParams["day"]}
          isRange={urlParams["isRange"]}
          startDate={urlParams["start_date"]}
          endDate={urlParams["end_date"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportSummaryDetailInsure":
      ReactDOM.render(
        <PrintReportSummaryDetailInsure
          type={urlParams["type"]}
          job_type={urlParams["job_type"]}
          year={urlParams["year"]}
          month={urlParams["month"]}
          day={urlParams["day"]}
          id={urlParams["id"]}
          viewForm={urlParams["viewForm"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintContinuousPaperConfig":
    case "PrintContinuousPaper":
      renderReactDOM(
        <HashRouter>
          <PrintContinuousPaperConfig
            pdfid={urlParams["pdfid"]}
            id={urlParams["id"]}
          />
        </HashRouter>,
        document.getElementById("root")
      );
      break;
    // case "PrintReportMechanicWork":
    //   ReactDOM.render(
    //     <PrintReportMechanicWork year={urlParams["year"]} month={urlParams["month"]} name={decodeURIComponent(urlParams["name"])} />, document.getElementById('root')
    //   );
    //   break;
    case "PdfContinuousPaper":
      ReactDOM.render(
        <PdfContinuousPaper pdfid={urlParams["pdfid"]} id={urlParams["id"]} />,
        document.getElementById("root")
      );
      break;
    case "PrintSSTWorkQCDoc":
      ReactDOM.render(
        <PrintSSTWorkQCDoc workNo={urlParams["wo"]} dn={urlParams["dn"]} />,
        document.getElementById("root")
      );
      break;
    case "PrintPaymentNoteDoc":
      renderReactDOM(
        <PrintPaymentNoteDoc pnNo={urlParams["pn"]} />,
        document.getElementById("root")
      );
      break;
    case "PrintGeneralSlipDoc":
      renderReactDOM(
        <PrintGeneralSlipDoc
          docNo={urlParams["doc_no"]}
          docName={urlParams["doc_name"]}
          showTaxInvoiceRefItem={urlParams["showTaxInvoiceRefItem"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintVoucherDoc":
      renderReactDOM(
        <PrintVoucherDoc
          docNo={urlParams["doc_no"]}
          docName={urlParams["doc_name"]}
          showTaxInvoiceRefItem={urlParams["showTaxInvoiceRefItem"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintCreditDebitDoc":
      renderReactDOM(
        <PrintCreditDebitDoc
          docNo={urlParams["doc_no"]}
          docName={urlParams["doc_name"]}
          showTaxInvoiceRefItem={urlParams["showTaxInvoiceRefItem"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportAnalysisBestJobcardProduct":
      ReactDOM.render(
        <PrintReportAnalysisBestJobcardProduct
          year={urlParams["year"]}
          month={urlParams["month"]}
          day={urlParams["day"]}
          isRange={urlParams["isRange"]}
          startDate={urlParams["start_date"]}
          endDate={urlParams["end_date"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportAnalysisBestPurchaseProduct":
      ReactDOM.render(
        <PrintReportAnalysisBestPurchaseProduct
          year={urlParams["year"]}
          month={urlParams["month"]}
          day={urlParams["day"]}
          isRange={urlParams["isRange"]}
          startDate={urlParams["start_date"]}
          endDate={urlParams["end_date"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportAnalysisBestPoShop":
      ReactDOM.render(
        <PrintReportAnalysisBestPoShop
          year={urlParams["year"]}
          month={urlParams["month"]}
          day={urlParams["day"]}
          isRange={urlParams["isRange"]}
          startDate={urlParams["start_date"]}
          endDate={urlParams["end_date"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportAnalysisBestJobcardService":
      ReactDOM.render(
        <PrintReportAnalysisBestJobcardService
          year={urlParams["year"]}
          month={urlParams["month"]}
          day={urlParams["day"]}
          isRange={urlParams["isRange"]}
          startDate={urlParams["start_date"]}
          endDate={urlParams["end_date"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportAnalysisBestJobcardBrand":
      ReactDOM.render(
        <PrintReportAnalysisBestJobcardBrand
          year={urlParams["year"]}
          month={urlParams["month"]}
          day={urlParams["day"]}
          isRange={urlParams["isRange"]}
          startDate={urlParams["start_date"]}
          endDate={urlParams["end_date"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportAnalysisBestJobcardInsurer":
      ReactDOM.render(
        <PrintReportAnalysisBestJobcardInsurer
          year={urlParams["year"]}
          month={urlParams["month"]}
          day={urlParams["day"]}
          isRange={urlParams["isRange"]}
          startDate={urlParams["start_date"]}
          endDate={urlParams["end_date"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintZongParkingCarDoc":
      ReactDOM.render(
        <PrintZongParkingCarDoc workNo={urlParams["wo"]} />,
        document.getElementById("root")
      );
      break;
    case "PrintZongBigJobDoc":
      ReactDOM.render(
        <PrintZongBigJobDoc workNo={urlParams["wo"]} />,
        document.getElementById("root")
      );
      break;
    case "PrintReportStockListInOut":
      renderReactDOM(
        <PrintReportStockListInOut
          start_date={urlParams["start_date"]}
          end_date={urlParams["end_date"]}
          typePrint={urlParams["type_print"]}
          typePrice={urlParams["type_price"]}
        />,
        document.getElementById("root")
      );
      break;
    case "ReportShopPurchaseOrder":
      ReactDOM.render(
        <ReportShopPurchaseOrder />,
        document.getElementById("root")
      );
      break;
    case "ReportEmployee":
      renderReactDOM(<ReportEmployee />, document.getElementById("root"));
      break;
    case "ReportEmployeeAbsence":
      ReactDOM.render(
        <ReportEmployeeAbsence />,
        document.getElementById("root")
      );
      break;
    case "ReportAdvanceSalary":
      ReactDOM.render(<ReportAdvanceSalary />, document.getElementById("root"));
      break;
    case "ReportSummary":
      ReactDOM.render(<ReportSummary />, document.getElementById("root"));
      break;
    case "ReportEmployeeAdvanceSalaryRecord":
      ReactDOM.render(
        <ReportEmployeeAdvanceSalaryRecord />,
        document.getElementById("root")
      );
      break;
    case "AccountSettings":
      renderReactDOM(
        <HashRouter>
          <AccountSettings workNo={urlParams["wo"]} />
        </HashRouter>,
        document.getElementById("root")
      );
      break;
    case "ReportWork":
      renderReactDOM(
        <ReportWork
          showParkingTab={urlParams["showParkingTab"] === "true"}
          showPrintEmptyDoc={urlParams["showPrintEmptyDoc"] === "true"}
        />,
        document.getElementById("root")
      );
      break;
    case "ReportAssetWork":
      renderReactDOM(
        <HashRouter>
          <ReportAssetWork
            showStatus={urlParams["showStatus"] === "1"}
            editMode={true}
          />
        </HashRouter>,
        document.getElementById("root")
      );
      break;
    case "ReportRefixedWork":
      renderReactDOM(
        <HashRouter>
          <ReportRefixedWork
            showParkingTab={urlParams["showParkingTab"] === "true"}
            showPrintEmptyDoc={urlParams["showPrintEmptyDoc"] === "true"}
          />
        </HashRouter>,
        document.getElementById("root")
      );

      break;
    case "ReportReceptionWork":
      renderReactDOM(
        <HashRouter>
          <ReportReceptionWork
            showParkingTab={urlParams["showParkingTab"] === "true"}
            showPrintEmptyDoc={urlParams["showPrintEmptyDoc"] === "true"}
          />
        </HashRouter>,
        document.getElementById("root")
      );

      break;
    case "ReportCashFlowRecord":
      ReactDOM.render(
        <ReportCashFlowRecord />,
        document.getElementById("root")
      );
      break;
    case "ReportSubscription":
      ReactDOM.render(<ReportSubscription />, document.getElementById("root"));
      break;
    case "ReportPickup":
      ReactDOM.render(<ReportPickup />, document.getElementById("root"));
      break;
    // case "ReportMechanicWork":
    //   ReactDOM.render(
    //     <ReportMechanicWork />, document.getElementById('root')
    //   );
    //   break;
    case "Plan":
      ReactDOM.render(<Plan />, document.getElementById("root"));
      break;
    case "ReportJobControlBoard":
      ReactDOM.render(
        <ReportJobControlBoard />,
        document.getElementById("root")
      );
      break;
    case "LangMenu":
      renderReactDOM(<LangMenu />, document.getElementById("root"));
      break;
    case "MessageMenu":
      ReactDOM.render(<MessageMenu />, document.getElementById("root"));
      break;
    case "MessageNoti":
      ReactDOM.render(
        <MessageNoti channel_id="realtime_debug" />,
        document.getElementById("root")
      );
      break;
    case "NotificationScheduleConfig":
      ReactDOM.render(
        <NotificationScheduleConfig
          workNo={urlParams["wo"]}
          showSaveButton={true}
          mobileNo={"0891034088"}
        />,
        document.getElementById("root")
      );
      break;
    case "RealtimeDebug":
      ReactDOM.render(<RealtimeDebug />, document.getElementById("root"));
      break;
    case "AdminConfig":
      ReactDOM.render(<AdminConfig />, document.getElementById("root"));
      break;
    case "PermissionTable":
      ReactDOM.render(<PermissionTable />, document.getElementById("root"));
      break;
    case "MessagePopup":
      ReactDOM.render(<MessagePopup />, document.getElementById("root"));
      break;
    case "InvoiceStatusMenuButton":
      renderReactDOM(
        <InvoiceStatusMenuButton ivNo={urlParams["iv"]} {...urlParams} />,
        document.getElementById("root")
      );
      break;
    case "PriceCompare":
      ReactDOM.render(
        <PriceCompare workNo={urlParams["wo"]} />,
        document.getElementById("root")
      );
      break;
    case "ReportPurchaseOrderPage":
      renderReactDOM(
        <ReportPurchaseOrderPage
          initPoNo={urlParams["po"]}
          showPRWaiting={true}
          showPO={true}
        />,
        document.getElementById("root")
      );
      break;
    case "ReportPettyCashPage":
      renderReactDOM(<ReportPettyCashPage />, document.getElementById("root"));
      break;
    case "ReportPartPriceComparePage":
      renderReactDOM(
        <HashRouter>
          <ReportPartPriceComparePage />
        </HashRouter>,
        document.getElementById("root")
      );
      break;
    case "ReportPriceComparePage":
      renderReactDOM(
        <HashRouter>
          <ReportPriceComparePage />
        </HashRouter>,
        document.getElementById("root")
      );
      break;
    case "WorkJobControlPage":
      renderReactDOM(<WorkJobControlPage />, document.getElementById("root"));
      break;
    case "PMJobControlPage":
      renderReactDOM(
        <WorkJobControlPage control={"pm"} />,
        document.getElementById("root")
      );
      break;
    case "WorkJobOfficeControlPage":
      renderReactDOM(
        <WorkJobOfficeControlPage />,
        document.getElementById("root")
      );
      break;
    case "RecheckControlPage":
      renderReactDOM(<RecheckControlPage />, document.getElementById("root"));
      break;
    case "BackupCarRegistration":
      renderReactDOM(
        <BackupCarRegistration />,
        document.getElementById("root")
      );
      break;
    case "BackupCarReservedButton":
      renderReactDOM(
        <BackupCarReservedButton {...urlParams} />,
        document.getElementById("root")
      );
      break;
    case "CarPlan":
      renderReactDOM(<CarPlan />, document.getElementById("root"));
      break;
    // case "CarTimeline":
    // renderReactDOM(
    //     <CarTimeline />, document.getElementById('root')
    // );
    // break;
    case "PMBoardTable":
      renderReactDOM(
        <PMBoardTable workNo={urlParams["wo"]} />,
        document.getElementById("root")
      );
      break;
    case "FixingOrderDoc":
      ReactDOM.render(<FixingOrderDoc />, document.getElementById("root"));
      break;
    case "WorkTimeRecord":
      ReactDOM.render(
        <WorkTimeRecord workNo={urlParams["wo"]} />,
        document.getElementById("root")
      );
      break;
    case "PrintFixingOrderDoc":
      ReactDOM.render(<PrintFixingOrderDoc />, document.getElementById("root"));
      break;
    case "PrintWorkJobPhoto":
      ReactDOM.render(
        <PrintWorkJobPhoto workNo={urlParams["wo"]} cat={urlParams["cat"]} />,
        document.getElementById("root")
      );
      break;
    case "PrintReportPOAndExpense":
      ReactDOM.render(
        <PrintReportPOAndExpense
          year={urlParams["year"]}
          month={urlParams["month"]}
          day={urlParams["day"]}
          typePrint={urlParams["type_print"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportKKCAllYearProfit":
      ReactDOM.render(
        <PrintReportKKCAllYearProfit
          year={urlParams["year"]}
          typePrint={urlParams["type_print"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportKKCAllYearIncomeOverview":
      ReactDOM.render(
        <PrintReportKKCAllYearIncomeOverview
          year={urlParams["year"]}
          typePrint={urlParams["type_print"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintKKCTaxInvoiceCoverNote":
      ReactDOM.render(
        <PrintKKCTaxInvoiceCoverNote tivList={urlParams["tivlist"]} />,
        document.getElementById("root")
      );
      break;
    case "PrintKKCTaxInvoiceCoverNoteInsurer":
      ReactDOM.render(
        <PrintKKCTaxInvoiceCoverNoteInsurer tivList={urlParams["tivlist"]} />,
        document.getElementById("root")
      );
      break;
    case "PrintSSTTaxInvoiceCoverNoteInsurer":
      ReactDOM.render(
        <PrintSSTTaxInvoiceCoverNoteInsurer tivList={urlParams["tivlist"]} />,
        document.getElementById("root")
      );
      break;
    case "PrintZongTaxInvoiceCoverNoteInsurer":
      ReactDOM.render(
        <PrintZongTaxInvoiceCoverNoteInsurer tivList={urlParams["tivlist"]} />,
        document.getElementById("root")
      );
      break;
    case "PrintORCFixingOrderDoc":
      ReactDOM.render(
        <PrintORCFixingOrderDoc workNo={urlParams["wo"]} />,
        document.getElementById("root")
      );
      break;
    case "PrintKKCBillingNoteCompany":
      ReactDOM.render(
        <PrintKKCBillingNoteCompany ivList={urlParams["ivlist"]}  dsList={urlParams["dslist"]} />,
        document.getElementById("root")
      );
      break;
    case "PrintKKCBillingNoteInsurer":
      ReactDOM.render(
        <PrintKKCBillingNoteInsurer ivList={urlParams["ivlist"]} />,
        document.getElementById("root")
      );
      break;
    case "PrintSSTBillingNoteInsurer":
      ReactDOM.render(
        <PrintSSTBillingNoteInsurer
          bn={urlParams["bn"]}
          ivList={urlParams["ivlist"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintShippingLabel":
      ReactDOM.render(
        <PrintShippingLabel
          idList={urlParams["idlist"]}
          docType={urlParams["doc"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintTLGTaxInvoiceCoverNoteInsurer":
      ReactDOM.render(
        <PrintTLGTaxInvoiceCoverNoteInsurer tivList={urlParams["tivlist"]} />,
        document.getElementById("root")
      );
      break;
    case "PrintTLGInvoiceDoc":
      ReactDOM.render(
        <PrintTLGInvoiceDoc ivList={urlParams["iv"]} />,
        document.getElementById("root")
      );
      break;
    case "PrintKKCDamagePartCheckList":
      ReactDOM.render(
        <PrintKKCDamagePartCheckList
          no={urlParams["number"]}
          carType={urlParams["car_type"]}
          workNo={urlParams["wo"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintPurchaseReceivedDoc":
      ReactDOM.render(
        <PrintPurchaseReceivedDoc
          recordType={urlParams["type"]}
          poNo={urlParams["po"]}
          shop={decodeURIComponent(urlParams["shop"])}
          car_registration={decodeURIComponent(urlParams["car_registration"])}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReceptionDoc":
      ReactDOM.render(
        <PrintReceptionDoc
          rcNo={urlParams["rc"]}
          shop={decodeURIComponent(urlParams["shop"])}
          car_registration={decodeURIComponent(urlParams["car_registration"])}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintTwoPagesInvoiceDoc":
      ReactDOM.render(
        <PrintTwoPagesInvoiceDoc ivNo={urlParams["iv"]} />,
        document.getElementById("root")
      );
      break;
    case "PrintTwoPagesTaxInvoiceDoc":
      ReactDOM.render(
        <PrintTwoPagesTaxInvoiceDoc tivNo={urlParams["tiv"]} />,
        document.getElementById("root")
      );
      break;
    case "PrintTwoPagesCashBillDoc":
      ReactDOM.render(
        <PrintTwoPagesCashBillDoc cbNo={urlParams["cb"]} />,
        document.getElementById("root")
      );
      break;
    case "PrintTwoPagesReceiptDoc":
      ReactDOM.render(
        <PrintTwoPagesReceiptDoc rcNo={urlParams["rc"]} />,
        document.getElementById("root")
      );
      break;
    case "PrintTwoPagesPurchaseOrderDoc":
      ReactDOM.render(
        <PrintTwoPagesPurchaseOrderDoc poNo={urlParams["po"]} />,
        document.getElementById("root")
      );
      break;
    case "PrintReportTJYIncentiveExpenseInsurance":
      ReactDOM.render(
        <PrintReportTJYIncentiveExpenseInsurance
          year={urlParams["year"]}
          month={urlParams["month"]}
          payeeValue={urlParams["payee_value"]}
          park={urlParams["park"]}
          noPark={urlParams["no_park"]}
          paidYet={urlParams["paid_yet"]}
          noPaidYet={urlParams["no_paid_yet"]}
          incentiveType={urlParams["incentive_type"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportCashflowRecord":
      ReactDOM.render(
        <PrintReportCashflowRecord
          isIncome={urlParams["money_received"]}
          isExpense={urlParams["money_spent"]}
          cat={decodeURIComponent(urlParams["cat"])}
          year={urlParams["year"]}
          month={urlParams["month"]}
          day={urlParams["day"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintWCSParkingCarDoc":
      ReactDOM.render(
        <PrintWCSParkingCarDoc workNo={urlParams["wo"]} />,
        document.getElementById("root")
      );
      break;
    case "PrintSSRParkingCarDoc":
      ReactDOM.render(
        <PrintWCSParkingCarDoc
          workNo={urlParams["wo"]}
          showPrice={urlParams["show_price"] === "false"}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintWCSCheckingCarDoc":
      ReactDOM.render(
        <PrintWCSCheckingCarDoc workNo={urlParams["wo"]} />,
        document.getElementById("root")
      );
      break;
    case "PrintWCSFixingOrderDoc":
      ReactDOM.render(
        <PrintWCSFixingOrderDoc workNo={urlParams["wo"]} />,
        document.getElementById("root")
      );
      break;
    case "PrintBHLParkingCarDoc":
      ReactDOM.render(
        <PrintBHLParkingCarDoc workNo={urlParams["wo"]} />,
        document.getElementById("root")
      );
      break;
    case "PrintBHLFixingListOnCarDoc":
      ReactDOM.render(
        <PrintBHLFixingListOnCarDoc workNo={urlParams["wo"]} />,
        document.getElementById("root")
      );
      break;
    case "PrintBNPInvoiceDoc":
      ReactDOM.render(
        <PrintBNPInvoiceDoc ivNo={urlParams["iv"]} />,
        document.getElementById("root")
      );
      break;
    case "PrintBNPTaxInvoiceDoc":
      ReactDOM.render(
        <PrintBNPTaxInvoiceDoc tivNo={urlParams["id"]} />,
        document.getElementById("root")
      );
      break;
    case "PrintSSRInvoiceDoc":
      ReactDOM.render(
        <PrintSSRInvoiceDoc ivNo={urlParams["iv"]} />,
        document.getElementById("root")
      );
      break;
    case "PrintZongInvoiceDoc":
      ReactDOM.render(
        <PrintZongInvoiceDoc ivNo={urlParams["iv"]} />,
        document.getElementById("root")
      );
      break;
    case "PrintZongTaxInvoiceDoc":
      ReactDOM.render(
        <PrintZongInvoiceDoc
          ivNo={urlParams["iv"]}
          doc="taxinvoice_doc"
          param="tiv"
        />,
        document.getElementById("root")
      );
      break;
    case "PrintKKCPhotobook":
      ReactDOM.render(
        <PrintKKCPhotobook workNo={urlParams["wo"]} />,
        document.getElementById("root")
      );
      break;
    case "PrintReportEmployee":
      ReactDOM.render(
        <PrintReportEmployee
          status={urlParams["status"]}
          query={urlParams["query"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintPGAAppointmentQueueDoc":
      ReactDOM.render(
        <PrintPGAAppointmentQueueDoc {...urlParams} />,
        document.getElementById("root")
      );
      break;
    case "PrintPGAWorkCoverFileDoc":
      ReactDOM.render(
        <PrintPGAWorkCoverFileDoc
          mode={urlParams["mode"]}
          workNo={urlParams["wo"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintPGABorrowingBackupcarDoc":
      ReactDOM.render(
        <PrintPGABorrowingBackupcarDoc {...urlParams} />,
        document.getElementById("root")
      );
      break;
    case "InsurerPageModal":
      ReactDOM.render(
        <InsurerPageModal show={true} showNew={true} />,
        document.getElementById("root")
      );
      break;
    case "SupplierPageModal":
      ReactDOM.render(
        <SupplierPageModal show={true} showNew={true} />,
        document.getElementById("root")
      );
      break;
    case "SelectParts":
      ReactDOM.render(<SelectParts />, document.getElementById("root"));
      break;
    case "WorkJobTimeTable":
      ReactDOM.render(<WorkJobTimeTable />, document.getElementById("root"));
      break;
    case "ReportPage":
      ReactDOM.render(<ReportPage />, document.getElementById("root"));
      break;
    case "ReportCategoryPage":
      renderReactDOM(
        <ReportCategoryPage showAdminMenu={true} />,
        document.getElementById("root")
      );
      break;
    case "WorkDocPurchaseOrder":
      renderReactDOM(
        <WorkDocPurchaseOrder workNo={urlParams["wo"]} />,
        document.getElementById("root")
      );
      break;
    case "WorkDocAttachmentDoc":
      renderReactDOM(
        <WorkDocAttachmentDoc workNo={urlParams["wo"]} />,
        document.getElementById("root")
      );
      break;
    case "PreviewWorkData":
      ReactDOM.render(
        <PreviewWorkDoc preview_id={urlParams["preview_id"]} />,
        document.getElementById("root")
      );
      break;
    case "LineMessagePage":
      ReactDOM.render(<LineMessagePage />, document.getElementById("root"));
      break;
    case "TestPlan":
      ReactDOM.render(<TestPlan />, document.getElementById("root"));
      break;
    case "StockManagementPage": {
      let config = Object.assign(
        {
          showOrder: true,
          showPickup: true,
          showLocation: true,
          showReplacement: true,
          showProductOption: false,
        },
        urlParams
      );
      renderReactDOM(
        <HashRouter>
          <StockManagementPage config={config} />
        </HashRouter>,
        document.getElementById("root")
      );
      break;
    }
    case "StockTyreManagementPage":
      renderReactDOM(
        <StockTyreManagementPage />,
        document.getElementById("root")
      );
      break;
    case "StockPainterBorrowingRecord":
      ReactDOM.render(
        <StockPainterBorrowingRecord open={true} />,
        document.getElementById("root")
      );
      break;
    case "StockToolBorrowingRecord":
      ReactDOM.render(
        <StockToolBorrowingRecord open={true} />,
        document.getElementById("root")
      );
      break;
    case "StockProductUsageRecord":
      ReactDOM.render(
        <StockProductUsageRecord show={true} stockType="officemate" />,
        document.getElementById("root")
      );
      break;
    case "StockSpecification":
      renderReactDOM(<StockSpecification />, document.getElementById("root"));
      break;
    case "PrintPreview":
      ReactDOM.render(<PrintPreview />, document.getElementById("root"));
      break;
    // case "PrintReportJobControlBoard":
    // ReactDOM.render(<PrintReportJobControlBoard control={urlParams["control"]} />, document.getElementById('root'));
    // break;
    case "PrintReportJobControlBoard":
      renderReactDOM(
        <PrintReportJobControlBoard
          control={urlParams["control"]}
          {...urlParams}
          status={urlParams["status"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintParkingCarDoc":
      ReactDOM.render(
        <PrintParkingCarDoc
          mode={urlParams["mode"]}
          workNo={urlParams["wo"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintExcelQuotationDoc":
      ReactDOM.render(
        <PrintExcelQuotationDoc
          qoNo={urlParams["qo"]}
          fileId={urlParams["fileId"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintQuotationDoc":
      ReactDOM.render(
        <PrintQuotationDoc
          qoNo={urlParams["qo"]}
          fileId={urlParams["fileId"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintQuotationDoc2":
      ReactDOM.render(
        <PrintQuotationDoc2
          qoNo={urlParams["qo"]}
          fileId={urlParams["fileId"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintWorkJobTimeTable":
      ReactDOM.render(
        <PrintWorkJobTimeTable
          mode={urlParams["mode"]}
          workNo={urlParams["wo"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintWorkOfficeJobTimeTable":
      ReactDOM.render(
        <PrintWorkOfficeJobTimeTable
          mode={urlParams["mode"]}
          workNo={urlParams["wo"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintSSTWorkCoverFileDoc":
      ReactDOM.render(
        <PrintSSTWorkCoverFileDoc
          mode={urlParams["mode"]}
          workNo={urlParams["wo"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintSSTFixingListOnCarDoc":
      ReactDOM.render(
        <PrintSSTFixingListOnCarDoc
          mode={urlParams["mode"]}
          workNo={urlParams["wo"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintNDMFixingListOnCarDoc":
      ReactDOM.render(
        <PrintNDMFixingListOnCarDoc
          mode={urlParams["mode"]}
          workNo={urlParams["wo"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintCheckingDamageDoc":
      ReactDOM.render(
        <PrintCheckingDamageDoc
          mode={urlParams["mode"]}
          workNo={urlParams["wo"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintSSTParkingCarDoc":
      ReactDOM.render(
        <PrintSSTParkingCarDoc
          mode={urlParams["mode"]}
          workNo={urlParams["wo"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintSSTWarrantyWorkDoc":
      ReactDOM.render(
        <PrintSSTWarrantyWorkDoc workNo={urlParams["wo"]} />,
        document.getElementById("root")
      );
      break;
    case "PrintSSTBigJobDoc":
      ReactDOM.render(
        <PrintSSTBigJobDoc workNo={urlParams["wo"]} />,
        document.getElementById("root")
      );
      break;
    case "PrintTNKBigJobDoc":
      ReactDOM.render(
        <PrintTNKBigJobDoc workNo={urlParams["wo"]} />,
        document.getElementById("root")
      );
      break;
    case "PrintTJYSalarySlipDoc":
      ReactDOM.render(
        <PrintTJYSalarySlipDoc
          periodic={urlParams["periodic"]}
          emType={urlParams["em_type"]}
          em={urlParams["em"]}
          ss={urlParams["ss"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintCarSummaryDoc":
      ReactDOM.render(
        <PrintCarSummaryDoc workNo={urlParams["wo"]} />,
        document.getElementById("root")
      );
      break;
    case "PrintKKCContractorQuotationDoc":
      ReactDOM.render(
        <PrintKKCContractorQuotationDoc
          workNo={urlParams["wo"]}
          employee_id={urlParams["employee_id"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportContractorWageTable":
      ReactDOM.render(
        <PrintReportContractorWageTable
          year={urlParams["year"]}
          month={urlParams["month"]}
          week={urlParams["week"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportContractorWageSlip":
      ReactDOM.render(
        <PrintReportContractorWageSlip
          slipList={urlParams["slipList"]}
          year={urlParams["year"]}
          month={urlParams["month"]}
          week={urlParams["week"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintSlipContractorDetail":
      ReactDOM.render(
        <PrintSlipContractorDetail
          periodic={urlParams["periodic"]}
          em={urlParams["em"]}
          slipId={urlParams["ss"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportSummarySlip":
      ReactDOM.render(
        <PrintReportSummarySlip
          year={urlParams["year"]}
          month={urlParams["month"]}
          between={urlParams["between"]}
          start={urlParams["start"]}
          end={urlParams["end"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportKKCIncome":
      ReactDOM.render(
        <PrintReportKKCIncome
          year={urlParams["year"]}
          month={urlParams["month"]}
          q={decodeURIComponent(urlParams["q"])}
          cat={urlParams["cat"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportKKCBalance":
      ReactDOM.render(
        <PrintReportKKCBalance
          year={urlParams["year"]}
          month={urlParams["month"]}
          q={decodeURIComponent(urlParams["q"])}
          cat={urlParams["cat"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintReportKKCReceivableCash":
      ReactDOM.render(
        <PrintReportKKCReceivableCash />,
        document.getElementById("root")
      );
      break;
    case "PrintReportKKCBillingNoteReceivable":
      ReactDOM.render(
        <PrintReportKKCBillingNoteReceivable />,
        document.getElementById("root")
      );
      break;
    case "SWTNewColorButton":
      ReactDOM.render(<SWTNewColorButton />, document.getElementById("root"));
      break;
    case "SWTNewInsurerButton":
      ReactDOM.render(<SWTNewInsurerButton />, document.getElementById("root"));
      break;
    case "EmployeeCodeButton": {
      if (urlParams["type"] === "qrcode") {
        let url =
          "https://demo2.bigfix.co/korat/qr/?startPage=TaskRegister&ex_emp_id=f7c63920-ffdd-11e7-b&bf_org_id=korat";
        ReactDOM.render(
          <EmployeeCodeButton
            type="qrcode"
            value={url}
            label="นายจักรกริช ทองรักษ์"
            subLabel="CK0001"
          />,
          document.getElementById("root")
        );
      } else {
        let url = "TJY1001";
        ReactDOM.render(
          <EmployeeCodeButton
            type="barcode"
            value={url}
            label="นายจักรกริช ทองรักษ์"
            subLabel="TJY1001"
          />,
          document.getElementById("root")
        );
      }
      break;
    }
    case "TutorialPage":
      ReactDOM.render(<TutorialPage />, document.getElementById("root"));
      break;
    case "StockMixPaintReport":
      ReactDOM.render(<StockMixPaintReport />, document.getElementById("root"));
      break;
    case "StockRequestReport":
      renderReactDOM(
        <HashRouter>
          <StockRequestReport />
        </HashRouter>,
        document.getElementById("root")
      );
      break;
    case "StockRequestDoc":
      ReactDOM.render(<StockRequestDoc />, document.getElementById("root"));
      break;
    case "StockAnyExportReport":
      renderReactDOM(
        <HashRouter>
          <StockAnyExportReport />
        </HashRouter>,
        document.getElementById("root")
      );
      break;
    case "Tracker":
      ReactDOM.render(<Tracker />, document.getElementById("root"));
      break;
    case "WorkTracker":
      renderReactDOM(
        <WorkTracker
          debug={"1"}
          startTaskAuto={urlParams["startTaskAuto"] === "true"}
          closeTimer={urlParams["closeTimer"]}
        />,
        document.getElementById("root")
      );
      break;
    case "WorkDocTimeline":
      ReactDOM.render(
        <WorkDocTimeline workNo={urlParams["wo"]} />,
        document.getElementById("root")
      );
      break;
    case "WorkDocMessage":
      ReactDOM.render(
        <WorkDocMessage workNo={urlParams["wo"]} />,
        document.getElementById("root")
      );
      break;
    case "MainDashboard":
      ReactDOM.render(<MainDashboard />, document.getElementById("root"));
      break;
    case "QuotationFileTreePage":
      ReactDOM.render(
        <QuotationFileTreePage />,
        document.getElementById("root")
      );
      break;
    case "SWTWorkUpload":
      ReactDOM.render(<SWTWorkUpload />, document.getElementById("root"));
      break;
    case "WorkDocGenForm":
      ReactDOM.render(<WorkDocGenForm />, document.getElementById("root"));
      break;
    case "WorkDocStock":
      ReactDOM.render(
        <WorkDocStock workNo={urlParams["wo"]} />,
        document.getElementById("root")
      );
      break;
    case "WorkDocInvoiceMenu":
      renderReactDOM(
        <WorkDocInvoiceMenu
          workNo={urlParams["wo"]}
          onCreateInvoice={(eventKey, postData, callback) => {
            callback();
          }}
        />,
        document.getElementById("root")
      );
      break;
    case "CashFlowRecord":
      ReactDOM.render(<CashFlowRecord />, document.getElementById("root"));
      break;
    case "IncentiveExpenseRecord":
      ReactDOM.render(
        <IncentiveExpenseRecord />,
        document.getElementById("root")
      );
      break;
    case "PartItemTable":
      ReactDOM.render(<PartItemTable />, document.getElementById("root"));
      break;
    case "TermOfServiceModal":
      ReactDOM.render(<TermOfServiceModal />, document.getElementById("root"));
      break;
    case "CarDamageDebug":
      ReactDOM.render(
        <CarDamageDebug wo={urlParams["wo"]} />,
        document.getElementById("root")
      );
      break;
    case "CarDamageContainer": {
      let wo = urlParams["wo"];
      if (wo === "" || wo === undefined) {
        wo = "KKC.0767/2561";
      }
      ReactDOM.render(
        <CarDamageContainer wo={wo} />,
        document.getElementById("root")
      );
      break;
    }
    case "NewWageItemModal":
      ReactDOM.render(
        <NewWageItemModal
          show={true}
          partID={11}
          carType={"truck"}
          onSave={(_) => console.log(_)}
        />,
        document.getElementById("root")
      );
      break;
    case "NewPartItemModal":
      ReactDOM.render(
        <NewPartItemModal
          show={true}
          partID={11}
          partTypeID={12}
          carType={"truck"}
          onSave={(_) => console.log(_)}
        />,
        document.getElementById("root")
      );
      break;
    case "DatePickerModal":
      ReactDOM.render(<DatePickerModal />, document.getElementById("root"));
      break;
    case "ReportTyreRepairPage":
      ReactDOM.render(
        <ReportTyreRepairPage />,
        document.getElementById("root")
      );
      break;
    case "ReportTyreRetirePage":
      ReactDOM.render(
        <ReportTyreRetirePage />,
        document.getElementById("root")
      );
      break;
    case "ReportTyreRepairInsidePage":
      renderReactDOM(
        <HashRouter>
          <ReportTyreRepairInsidePage />
        </HashRouter>,
        document.getElementById("root")
      );
      break;
    case "ReportTyreReceptionPage":
      renderReactDOM(
        <HashRouter>
          <ReportTyreReceptionPage />
        </HashRouter>,
        document.getElementById("root")
      );
      break;
    case "ReportTyreVehicleRegistrationPage":
      renderReactDOM(
        <HashRouter>
          <ReportTyreVehicleRegistrationPage />
        </HashRouter>,
        document.getElementById("root")
      );
      break;
    case "ReportAllTyreRepairPage":
      renderReactDOM(
        <HashRouter>
          <ReportAllTyreRepairPage />
        </HashRouter>,
        document.getElementById("root")
      );
      break;
    case "ReportAssetVehiclePage":
      renderReactDOM(
        <HashRouter>
          <ReportAssetVehiclePage />
        </HashRouter>,
        document.getElementById("root")
      );
      break;
    case "ReportAllAssetPage":
      renderReactDOM(
        <HashRouter>
          <ReportAllAssetPage />
        </HashRouter>,
        document.getElementById("root")
      );
      break;
    case "AssetDoc":
      renderReactDOM(
        <HashRouter>
          <AssetDoc assetId={1} showInfoOnly={true} readOnly={true} />
        </HashRouter>,
        document.getElementById("root")
      );
      break;
    case "AssetVehicleDoc":
      renderReactDOM(
        <HashRouter>
          <AssetVehicleDoc vehicleId={1} showInfoOnly={true} readOnly={true} />
        </HashRouter>,
        document.getElementById("root")
      );
      break;
    case "PrintTyreRepairDoc":
      ReactDOM.render(
        <PrintTyreRepairDoc trNo={urlParams["trNo"]} />,
        document.getElementById("root")
      );
      break;
    case "PrintTyreRetireDoc":
      ReactDOM.render(
        <PrintTyreRetireDoc trNo={urlParams["trNo"]} />,
        document.getElementById("root")
      );
      break;
    case "ScheduledServicePlan":
      renderReactDOM(
        <HashRouter>
          <ScheduledServicePlan workNo={urlParams["wo"]} />
        </HashRouter>,
        document.getElementById("root")
      );
      break;
    case "EmployeeEditPage":
      renderReactDOM(
        <HashRouter>
          <EmployeeEditPage />
        </HashRouter>,
        document.getElementById("root")
      );
      break;
    case "ReportAppointmentReturn":
      renderReactDOM(
        <ReportAppointmentReturn />,
        document.getElementById("root")
      );
      break;
    case "PrintDearTaxInvoiceDoc":
      renderReactDOM(
        <PrintDearTaxInvoiceDoc
          tivNo={urlParams["iv"]}
          doc="taxinvoice_doc"
          param="tiv"
          header_style={urlParams["header_style"]}
        />,
        document.getElementById("root")
      );
      break;
    case "PrintDearPartDisposebyReturn":
      renderReactDOM(
        <PrintDearPartDisposebyReturn workNo={urlParams["wo"]} />,
        document.getElementById("root")
      );
      break;
    case "PrintDeliveryCarDoc":
      ReactDOM.render(
        <PrintDeliveryCarDoc workNo={urlParams["wo"]} dn={urlParams["dn"]} />,
        document.getElementById("root")
      );
      break;
    case "ReportAnalysisWorkCustomCost":
      ReactDOM.render(
        <ReportAnalysisWorkCustomCost
          renderMenu={() => {
            return <div />;
          }}
          {...urlParams}
        />,
        document.getElementById("root")
      );
      break;
    default:
      // ReactDOM.render(<App />, document.getElementById('root'));
      break;
  }
}



// WEBPACK FOOTER //
// ./src/index-dev.js